import { z } from 'zod'

export const passwordFormSchema = z
  .object({
    password: z
      .string()
      .trim()
      .min(1, 'Password is required')
      .min(6, 'Password must be at least 6 characters')
      .regex(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).*$/,
        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
      ),
    confirmPassword: z.string().trim().min(1, 'Please confirm your password')
  })
  .refine(data => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword']
  })

export type PasswordFormValues = z.infer<typeof passwordFormSchema>

export const defaultPasswordFormValues: PasswordFormValues = {
  password: '',
  confirmPassword: ''
}
